import {
  ChallengeType,
  type RegisterIdentity,
  type RequestAttestation,
} from '~/interfaces/auth';

import { SignupHandler } from './signup-handler';

export class MetaMaskHandler extends SignupHandler<
  RequestAttestation,
  RegisterIdentity
> {
  protected transformRequestBody(body: RequestAttestation): RegisterIdentity {
    if (!body.sig || !body.alias || !body.originalChallengeParams) {
      throw new Error('Invalid request body');
    }

    const phone = body.data.phone;

    return {
      assertion_result: {
        challengeType: ChallengeType.SIGNING_CHALLENGE,
        alias: body.alias,
        value: {
          signature: body.sig,
          alias: body.alias,
        },
        originalChallengeParams: body.originalChallengeParams,
      },
      extra_context: {},
      type: 'individual',
      profile: {
        first_name: body.data.name,
        last_name: body.data.lastName,
        email: body.data.email,
        phone: phone,
      },
    };
  }
}
